module.exports = __webpack_public_path__ + "components/flag/static/square/tf-83bcfb3687b0c9d07663386191b85e87.svg";